import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCartIcon, ShieldCheckIcon, GiftIcon } from 'lucide-react';
import { fbq } from '../App';
const CHECKOUT_URL = 'https://www.tumomentovital.com/cart/47625937879232:1';
export function StickyBuyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleClick = () => {
    fbq('track', 'AddToCart', {
      content_name: 'Social Hacker v1.0',
      content_type: 'product',
      value: 9.99,
      currency: 'USD'
    });
    window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
  };
  return <AnimatePresence data-id="element-569">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-0 left-0 right-0 z-[60] bg-cyber-black/95 backdrop-blur-md border-t border-cyber-neon/40 px-4 py-3 shadow-[0_-4px_30px_rgba(57,255,20,0.15)]" data-id="element-570">
          <div className="max-w-xl mx-auto flex items-center justify-between gap-3" data-id="element-571">
            <div className="flex flex-col" data-id="element-572">
              <div className="flex items-center gap-2" data-id="element-573">
                <span className="text-gray-500 text-xs line-through" data-id="element-574">$121</span>
                <span className="text-cyber-neon font-mono font-bold text-xl" data-id="element-575">
                  $9.99
                </span>
                <span className="bg-cyber-red/20 text-cyber-red text-[10px] font-bold px-1.5 py-0.5 rounded font-mono" data-id="element-576">
                  -92%
                </span>
              </div>
              <div className="flex items-center gap-2 text-[10px]" data-id="element-577">
                <span className="flex items-center gap-1" data-id="element-578">
                  <GiftIcon className="w-3 h-3 text-cyber-neon animate-pulse" data-id="element-579" />
                  <span className="text-gray-400" data-id="element-580">
                    + 2 Bonos{' '}
                    <strong className="text-cyber-neon" data-id="element-581">GRATIS</strong>
                  </span>
                </span>
                <button onClick={e => {
              e.stopPropagation();
              document.getElementById('bonos')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="text-cyber-neon underline underline-offset-2" data-id="element-582">
                  Ver
                </button>
              </div>
            </div>
            <motion.button whileTap={{
          scale: 0.95
        }} onClick={handleClick} className="bg-cyber-neon text-cyber-black font-mono font-bold text-sm px-5 py-3 rounded-lg shadow-neon hover:shadow-neon-strong transition-all flex items-center gap-2 shrink-0" data-id="element-583">
              <ShoppingCartIcon className="w-4 h-4" data-id="element-584" />
              COMPRAR AHORA
            </motion.button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}